import { FunctionComponent, useEffect, useState } from 'react';
import { IconInfo } from '@lmig/lmds-react-icons';
import { Link } from '@lmig/lmds-react-link';
import './PolicyLookup.scss';
import { useUserData } from 'Foundation/User/UserContext';
import { Heading, Caption } from '@lmig/lmds-react-typography';
import { Gem } from '@lmig/lmds-react-gem';
import BillingSummary from './BillingSummary';
import PolicySummary from './PolicySummary';
import ClaimSummary from './ClaimSummary';
import { useLocation } from 'react-router-dom';
import { Notification } from '@lmig/lmds-react-notification';

const PolicyLookup: FunctionComponent<IPolicyLookupProps> = (props: IPolicyLookupProps) => {
  const { userData } = useUserData();
  const [showError, setShowError] = useState<boolean>(false);
  const { search } = useLocation();
  const [policyNumber] = useState<string | null>(new URLSearchParams(search).get('policyNumber'));
  const [formattedPolicyNumber, setFormattedPolicyNumber] = useState<string | null>();

  useEffect(() => {
    if (policyNumber) {
      let formatted: string = policyNumber.split(' ').join('').replaceAll('(', '').replaceAll(')', '').toUpperCase();
      if (formatted && formattedPolicyNumber !== formatted) setFormattedPolicyNumber(formatted);
    }
  }, [policyNumber]);

  const callback = () => {
    if (userData?.selectedStatCodeData?.SubStat == '') setShowError(true);
  };

  if (userData)
    return (
      <div className="account-summary">
        <Heading type="h3-light">Results For #: {policyNumber}</Heading>
        <hr />
        <div className="account-summary-head">
          <div>Agency code: {userData.selectedStatCodeData.SubStat}</div>
        </div>
        {props.includeRelatedPolicies && (
          <div style={{ alignItems: 'flex-start', display: 'flex' }}>
            <Gem highlightType="informative" style={{ marginRight: '8px' }}>
              <IconInfo color="informative" size="16" />
            </Gem>
            <Caption>
              "Include Related Policies" is only available for policies issued through Commercial Lines IQ and enhanced
              Commercial Lines IQ. For policies issued on other systems, please search by Insured Name to see all your
              insured’s policies in one view. For Safeco policy data, go to{' '}
              <Link href="https://now.agent.safeco.com" target="_blank">
                SafecoNow
              </Link>
              . For help, contact the Help Desk 1-888-451-8414.
            </Caption>
          </div>
        )}
        {!showError && formattedPolicyNumber ? (
          <>
            <BillingSummary policyNumber={formattedPolicyNumber} callback={() => callback()} />
            <PolicySummary policyNumber={formattedPolicyNumber} callback={() => callback()} />
            <ClaimSummary policyNumber={formattedPolicyNumber} callback={() => callback()} />
          </>
        ) : (
          <Notification alert="Please try again later." highlightType="negative">
            The data for this agency/policy is temporarily unavailable. If this issue persists, please contact Agency
            Interface Support Group at 888-451-8414.
          </Notification>
        )}
      </div>
    );
  else return null;
};

export default PolicyLookup;
